const riot = require('riot');

riot.tag2('page-distribution-rules-single-edit', '<div class="f s-full"> <div data-is="module-sidebar"></div> <form class="s-full f fclm overflow-scroll bg-pale_gray" if="{isShow}" onsubmit="{onSubmit}"> <div data-is="module-page-header" back="{getBackRoute()}" title="配布ルールの新規作成" breadcrumbs="{breadcrumbs}"> <yield to="badge"> <div if="{parent.distributionRule}" data-is="atom-distribution_rule_status-badge" item="{parent.distributionRule}"></div> </yield> <yield to="right"> <button class="button primary">下書き保存</button> </yield> </div> <div class="f fclm p40"> <div class="f fclm py32 rounded-8 bg-white elevation-default-low mb32" if="{isRaffle}"> <div class="px32"> <p class="ts-ps text-navy">ユーザーは「抽選画面」にアクセスし、抽選を実行した後、抽選配分で定められた確率に基づいて当選します<br><br>抽選配布ルールの基本的な設定をしてください<br>抽選配分で確率と上限人数、1人にくばる金額を設定してください<br>各抽選結果で表示される画面と抽選画像や文言をカスタマイズできます<br>エクスポートされるCSVは抽選画面へアクセスするURLが記載されています。<br></p> </div> </div> <div class="f fclm py32 rounded-8 bg-white elevation-default-low mb32"> <div class="px32"> <div class="mb32"> <div class="mb36" data-is="module-section-header" title="基本設定"> </div> <label class="block"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">配布ルール名</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <input class="input w-full" ref="name" type="text" required placeholder="配布ルール名を入力" oninput="{changeData}"> </label> </div> <div> <div class="mb24"> <div class="ts-hxs text-gray_60 mb8">配布方法</div> <div class="ts-pm text-navy">{getLabel(app.data.constants.distribution_target_types, isRaffle ? ⁗raffle⁗: ⁗all⁗)}</div> </div> <div class="mb24"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">ポイントサービス</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <div class="f fm mb8"> <label class="f fm cursor-pointer mr12 mr0-last" each="{option, i in radioOptions}"> <input class="radio mr8" ref="radio" type="radio" riot-value="{option.id}" name="select" onchange="{onChangeOption}" checked="{option.checked}"> <div class="ts-ps text-navy">{option.label}</div> </label> </div> <div class="ts-pxs text-gray_60 mb8">配布するポイントのサービスを選択できます</div> <div class="w500" if="{!pointProviderSelectionEnabled}" data-is="atom-input-select" ref="point_provider_pull_down" options="{providerOptionsWithTest}" riot-value="{selectedFixedProviderId}" oninput="{onInputProvider}" required></div> <div if="{pointProviderSelectionEnabled}"> <div each="{option in providerOptions}"> <label class="f fm cursor-pointer mb8"> <input class="checkbox mr10" ref="point_provider_checkbox" type="checkbox" riot-value="{option.id}" onchange="{onChangeSelectedProvider}" checked="{selectedProviderIds.includes(option.id)}"> <div>{option.name}</div> </label> </div> </div> </div> <div class="mb24" if="{!pointProviderSelectionEnabled}"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">ポイント付与回数の制限</div> </div> <div class="ts-pxs text-gray_60 mb8">同じPayPayアカウントがこの配布ルールによる特典を何度も受け取れないよう制限できます。この設定はPayPayの場合のみ有効です。</div> <label class="f fm"> <input class="checkbox mr10" ref="no_duplicate_account" type="checkbox" onchange="{onChangeNoDuplicateAccount}" checked="{noDuplicateAccountChecked}" disabled="{!refs.point_provider_pull_down.getValue() || refs.point_provider_pull_down.getValue() !== &quot;paypay&quot;}"> <div class="ts-ps text-navy cursor-pointer">1アカウントあたり1回までに制限</div> </label> </div> <div> <div class="ts-hxs text-gray_80 mb8">自動アーカイブ設定</div> <div class="ts-pxs text-gray_60 mb8">システム負荷軽減のため配布ルールは自動でアーカイブされます。<br>この配布ルールで配布を行なう期間の末日から90日以上の日付が設定できます。<br>APIでの利用など、この配布ルールを恒常的に利用する場合はアーカイブ日を指定しないを選択してください。</div> <div class="f fm"> <input class="input cursor-pointer mr12" ref="archive_date" min="{dayjs().add(90, &quot;d&quot;).format(&quot;YYYY-MM-DD&quot;)}" riot-value="{dayjs().add(180, &quot;d&quot;).format(&quot;YYYY-MM-DD&quot;)}" disabled="{refs.is_unset_archive.checked}" onchange="{changeData}" type="{\'date\'}"> <label class="f fm"> <input class="checkbox mr10" ref="is_unset_archive" type="checkbox" onchange="{changeData}" checked="{!distributionRule.archive_at}"> <div class="ts-ps text-navy cursor-pointer">アーカイブ日を指定しない</div> </label> </div> </div> </div> </div> </div> <div class="f fclm py32 rounded-8 bg-white elevation-default-low mb32" if="{isRaffle}"> <div class="px32"> <div class="mb60" data-is="module-section-header" title="抽選設定"></div> <div class="mb32"> <div class="ts-hs text-navy mb32">抽選期間</div> <label class="f fm mb32"> <input class="checkbox mr10" ref="is_all_win" type="checkbox" onchange="{changeData}" checked="{false}"> <div class="ts-ps text-navy cursor-pointer">抽選結果から「ハズレ」を取り除く</div> </label> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">抽選の終了日</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <div class="ts-pxs text-gray_60 mb8">設定された日の23:59までがユーザーが抽選できます。以降は抽選ができなくなります</div> <div class="f fm"> <input class="input w160 cursor-pointer mr12" min="{dayjs().format(&quot;YYYY-MM-DD&quot;)}" max="{refs.is_unset_archive.checked ? null : refs.archive_date.value}" oninput="{refs.rafflePreview.bindRaffleRule(&quot;close_at&quot;, &quot;general&quot;)}" required type="date"> </div> </div> <div class="mb32"> <div class="ts-hs text-navy mb32">抽選配分</div> <div data-is="atom-input-raffle-patterns" ref="rafflePatterns" point-providers="{pointProviderSelectionEnabled ? selectedProviderIds : [].concat(selectedFixedProviderId || [])}" is-all-win="{refs.is_all_win.checked}"></div> </div> <div class="mb32"> <div class="ts-hs text-navy mb20">画面カスタマイズ</div> <p class="ts-pxs text-gray_60 mb28">ユーザーが引いた抽選結果ごとに出す画面のカスタマイズができます<br>くじびき抽選を行う画面「抽選画面」のカスタマイズができます</p> <div data-is="atom-input-raffle-preview" ref="rafflePreview" length="{refs.rafflePatterns.getPatternsLength()}" campaign="{campaign}" is-all-win="{refs.is_all_win.checked}"></div> </div> </div> </div> </div> </form> </div>', 'page-distribution-rules-single-edit,[data-is="page-distribution-rules-single-edit"]{display:block}', '', function(opts) {
    this.limit = 50;

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      var companyId = req.params.company_id;
      var projectId = req.params.project_id;
      var campaignId = req.params.campaign_id;
      var distribution_rule_id = req.params.distribution_rule_id;
      var isRaffle = req.query.type === 'raffle';
      if (isRaffle) {
        var { campaign } = await app.api.child(`companies/${companyId}/projects/${projectId}/campaigns/${campaignId}`).get();
      }

      var promises = [
        app.api.child(`companies/${companyId}/point_providers`).get(),
      ];
      var [{ company_point_providers }] = await Promise.all(promises);

      this.pointProviderSelectionEnabled = false;

      this.radioOptions = [
        {
          id: 'fixed',
          label: 'ポイント種別を固定する',
          checked: !this.pointProviderSelectionEnabled,
        },
        {
          id: 'selectable',
          label: 'ユーザーがポイント種別を選択できる',
          checked: this.pointProviderSelectionEnabled,
        },
      ];

      this.providerOptionsWithTest = app.utils.getProviderOptionsWithTest(company_point_providers);

      this.providerOptions = app.utils.getProviderOptions(company_point_providers);

      this.selectedFixedProviderId = this.providerOptionsWithTest[0].id || '';

      this.selectedProviderIds = this.providerOptions.map(p => p.id);
      this.noDuplicateAccountChecked = false;

      return {
        companyId,
        projectId,
        campaign,
        campaignId,
        isRaffle,
        breadcrumbs: [],
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title('配布ルールの新規作成', this),
      };
    };

    this.on('show', () => {
      this.reset();
    });

    this.on('beforeunload', (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.on('datachange', () => {
      this.changeData();
      this.update();
    });

    this.on('addRafflePattern', ({ index }) => {
      this.refs.rafflePreview.addTab(index);
    });

    this.on('removeRafflePattern', ({ index }) => {
      this.refs.rafflePreview.removeTab(index);
    });

    this.onSubmit = async (e) => {
      e.preventDefault();

      if (this.pointProviderSelectionEnabled) {
        this.noDuplicateAccountChecked = false;
      }

      if (this.pointProviderSelectionEnabled && !this.selectedProviderIds.length) {
        spat.modal.alert('少なくとも1つ以上ポイントサービスを選択してください。');
        return ;
      }
      var indicator = spat.modal.indicator();
      try {
        let point_providers = !this.pointProviderSelectionEnabled ? [].concat(this.selectedFixedProviderId || []) : this.selectedProviderIds;

        var archive_at = this.refs.is_unset_archive.checked ? 0 : dayjs(this.refs.archive_date.value).valueOf();
        var query = {
          campaign_id: this.campaignId,
          distribution_target_type: this.isRaffle ? 'raffle' : 'all',
          name: this.refs.name.value,
          point_provider_selection_enabled: this.pointProviderSelectionEnabled,
          point_providers,
          archive_at,
          no_duplicate_account: !this.pointProviderSelectionEnabled ? this.noDuplicateAccountChecked : false,
        };

        if (this.isRaffle) {
          const raffle_patterns = this.refs.rafflePatterns.getValue();
          if (!raffle_patterns) return ;
          const image_api = app.api.child(`companies/${this.companyId}/projects/${this.projectId}/distribution_rules/signed_url_by_raffle_rule`);
          let [raffle_rule, raffle_result_patterns] = await this.refs.rafflePreview.getValue({ image_api });
          raffle_result_patterns.forEach((p, i) => {
            Object.assign(p, raffle_patterns[i]);
          });

          raffle_rule.is_allwin = this.refs.is_all_win.checked;
          Object.assign(query, {
            raffle_rule,
            raffle_result_patterns,
          });
        }
        Object.assign(query, {
          status: 'draft',
        });
        var {distribution_rule} = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/distribution_rules`).post(query);

        spat.modal.alert('作成しました');
        spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaignId}/distribution_rules/${distribution_rule.id}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.getBackRoute = () => {
      return `/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaignId}`;
    };

    this.changeData = (e) => {
      this.isChange = true;
    };

    this.onChangeOption = (e) => {
      let value = e.currentTarget.value;
      if (value === 'selectable') {
        this.pointProviderSelectionEnabled = true;
        this.noDuplicateAccountChecked = false;
      } else {
        this.pointProviderSelectionEnabled = false;
      }
      this.update();
    }

    this.onInputProvider = () => {
      this.changeData();
      if (this.refs.point_provider_pull_down.getValue() !== 'paypay') {
        this.noDuplicateAccountChecked = false;
      }
      this.selectedFixedProviderId = this.refs.point_provider_pull_down.getValue();
    };

    this.onChangeSelectedProvider = (e) => {
      this.changeData();
      this.selectedProviderIds = [].concat(this.refs.point_provider_checkbox || []).filter(checkbox => checkbox.checked).map(input => input.value);
    };

    this.onChangeNoDuplicateAccount = (e) => {
      this.changeData();
      this.noDuplicateAccountChecked = e.currentTarget.checked;
    };

    this.reset = () => {

      this.update({ isShow: false });
      this.update({
        isShow: true,

        files: [],
        isChange: false,
      });
    };

    this.getLabel = (types, value) => {
      return types.find(t => t.id === value).name;
    };
});